module.exports = __webpack_public_path__ + "kn.b5a85f0f5a37ef86d805.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/kn.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/kn.svg
// module chunks = styles